var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-lightweight-chart"},[_vm._t("top"),_c('div',{ref:"chartContainer",staticClass:"f-lightweight-chart__container"}),_vm._t("bottom")],2)}
var staticRenderFns = []

export { render, staticRenderFns }